import { mediaQuery } from './media-query';

jQuery(document).ready(() => {

    mediaQuery(
      'max',
      'width',
      '767',
      () => {
        // Mobile do anything
        console.log('');
      }
    );
  
});
customTabs();
planosTabs();

function customTabs() {
    let tab = jQuery(".custom-tabs>a");
    let tabContent = jQuery(".tab-content");
    tab.on('click', function(e){
        e.preventDefault;

        let target = jQuery(this).attr("href");
        tab.removeClass('active');
        tabContent.removeClass('active');
        jQuery(this).addClass('active');
        jQuery(".tab-content"+target).addClass('active');
        console.log(target);
        return false;
    });
}

function planosTabs() {
    let tab = jQuery(".tabs-planos>.tabs-links>li>a");
    let tabContent = jQuery(".plano-tab-container");
    tab.first().addClass('active');
    tabContent.first().addClass('active');
    tab.on('click', function(e){
        e.preventDefault;

        let target = jQuery(this).attr("href");
        //console.log(target);
        tab.removeClass('active');
        tabContent.removeClass('active');
        jQuery(this).addClass('active');
        jQuery(target).addClass('active');
        return false;
    });
}